module.exports = __webpack_public_path__ + "img/b2665bf.webp";